import React, { useState } from 'react';
import GlassesAnimation from './3dScene/GlassesViewer';
import styles from './GlassesDemo.module.css';

const GlassesDemo = ({ isVisible = false }) => {
  const [debugInfo, setDebugInfo] = useState({
    phase: 'zoom',
    scrollPercent: '0.000',
    cameraZ: '3.00',
    modelRotationY: '0',
    currentStep: 0
  });

  const section1Visible = debugInfo.currentStep >= 15 && debugInfo.currentStep < 60;
  const section2Visible = debugInfo.currentStep >= 70 && debugInfo.currentStep < 120;
  const section3Visible = debugInfo.currentStep >= 120 && debugInfo.currentStep < 180;
  const section4Visible = debugInfo.currentStep >= 220 && debugInfo.currentStep < 240;
  const section5Visible = debugInfo.currentStep >= 240 && debugInfo.currentStep < 260;
  const section6Visible = debugInfo.currentStep >= 270 && debugInfo.currentStep < 300;

  const isViewerVisible = debugInfo.phase !== 'hide';

  return (
    <div className={styles.SceneContainer}>
      <div className={`${styles.viewerContainer} ${isViewerVisible ? styles.visible : styles.hide}`}>
        <GlassesAnimation onAnimationUpdate={setDebugInfo} />
      </div>
      
      {/* Debug Dashboard */}
      <div className={styles.debugDashboard}>
        <h3>Debug Info</h3>
        <table>
          <tbody>
            <tr>
              <td>Current Step:</td>
              <td>{debugInfo.currentStep}</td>
            </tr>
            <tr>
              <td>Animation Phase:</td>
              <td>{debugInfo.phase}</td>
            </tr>
            <tr>
              <td>Scroll Progress:</td>
              <td>{debugInfo.scrollPercent}</td>
            </tr>
            <tr>
              <td>Camera Z Position:</td>
              <td>{debugInfo.cameraZ}</td>
            </tr>
            <tr>
              <td>Model Y Rotation:</td>
              <td>{debugInfo.modelRotationY}°</td>
            </tr>
          </tbody>
        </table>
      </div>
      
      <div className={styles.contentContainer}>
        <div className={styles.content}>
          <section className={`${styles.section} ${section1Visible ? styles.visible : ''}`}>
            <h1 className={styles.title}>
              Now, you can unlock it with Rayvo and Web3.
            </h1>
          </section>

          <section className={`${styles.section} ${section2Visible ? styles.visible : ''}`}>
            <h2 className={styles.subtitle}>
              Capture Value
            </h2>
            <p className={styles.description}>
              Rayvo empowers your Sight Value by transforming everyday visual datas into tangible rewards.
            </p>
          </section>

          <section className={`${styles.section} ${section3Visible ? styles.visible : ''}`}>
            <h2 className={styles.subtitle}>
              World's First 16MP Smartglasses Camera
            </h2>
            <p className={styles.description}>
              4K crystal moments | 1080P fluid memories | Up to 5min continuous 4K capture.
            </p>
          </section>

          <section className={`${styles.section} ${section4Visible ? styles.visible : ''}`}>
            <h1 className={styles.title}>
            Always-On AI Companion
            </h1>
          </section>

          <section className={`${styles.section} ${section5Visible ? styles.visible : ''}`}>
            <h2 className={styles.subtitle}>
            ChatGPT-4o Real-Time Assistance.
            </h2>
            <p className={styles.description}>
              Instant Visual Translation, Signs, Menus, Documents Memory Capsule.
              Auto-Recognize and Capture Key Moments Work Accelerator, Meeting Notes + AI Summaries.
            </p>
          </section>

          <section className={`${styles.section} ${section6Visible ? styles.visible : ''}`}>
            <h2 className={styles.subtitle}>
              Ergonomic Design
            </h2>
            <p className={styles.description}>
              Aerospace-Grade Titanium Hinges | Adjustable Nose Pads | All-Day Comfort Certification | Universal Face Fit.
            </p>
          </section>
          
        </div>
      </div>
    </div>
  );
};

export default GlassesDemo; 